import POIStep from "@/components/POI/POIStep/POIStep.vue";

export default {
  name: "OnlineLinks",
  components: { POIStep },
  props: ["editedItem", "step", "position", "isOwnedBySubPrincipal"],
  methods: {
    changeStep(position) {
      this.$emit("changeStep", position);
    }
  }
};
